<a *ngIf="linkConfig && icon" class="copo-datacenter-grid-icon-link datacenter-total-hidden"
	[routerLink]="linkConfig.commands"
	[fragment]="linkConfig.extras?.fragment"
	[preserveFragment]="linkConfig.extras?.preserveFragment || false"
	[queryParams]="linkConfig.extras?.queryParams"
	[queryParamsHandling]="linkConfig.extras?.queryParamsHandling"
	[relativeTo]="linkConfig.extras?.relativeTo"
	[replaceUrl]="linkConfig.extras?.replaceUrl || false"
	[skipLocationChange]="linkConfig.extras?.skipLocationChange || false"
	[state]="linkConfig.extras?.state"
><mat-icon [svgIcon]="icon" class="copo-datacenter-grid-icon-16"></mat-icon></a>